import { ref } from 'vue'

// Module-level state on purpose: the topbar's hamburger and the sidebar's drawer are
// two components that must agree on one open/closed flag, and a layout has exactly one
// menu. A per-component ref would leave the toggle talking to nothing.
const mobileMenuOpen = ref(false)

export const useLayout = () => {
    const openMobileMenu   = () => { mobileMenuOpen.value = true }
    const closeMobileMenu  = () => { mobileMenuOpen.value = false }
    const toggleMobileMenu = () => { mobileMenuOpen.value = !mobileMenuOpen.value }

    return { mobileMenuOpen, openMobileMenu, closeMobileMenu, toggleMobileMenu }
}
